import { graphql } from 'gql';

export const worKOrderCodeFilterGql = graphql(`
    query uerWorkOrderPriceCodeFilter(
        $workOrderId: Long!
        $chapter: ChapterEnum!
        $workOrderPriceObjectId: Long!
        $where: FilterValueOfWorkOrderPriceCodeFilterDataFilterInput
        $order: [FilterValueOfWorkOrderPriceCodeFilterDataSortInput!]
    ) {
        uerWorkOrderPriceCodeFilter(
            workOrderId: $workOrderId
            chapter: $chapter
            workOrderPriceObjectId: $workOrderPriceObjectId
            where: $where
            order: $order
        ) {
            items {
                value {
                    uerCode
                    code
                    isUer
                    isRatio
                    isMtr
                }
            }
        }
    }
`);

export const workOrderStatusFilterGql = graphql(`
    query uerWorkOrderPriceStatusFilter($workOrderId: Long!, $chapter: ChapterEnum!, $workOrderPriceObjectId: Long!) {
        uerWorkOrderPriceStatusFilter(
            workOrderId: $workOrderId
            chapter: $chapter
            workOrderPriceObjectId: $workOrderPriceObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const workOrderNameFilterGql = graphql(`
    query uerWorkOrderPriceNameFilter(
        $workOrderId: Long!
        $chapter: ChapterEnum!
        $workOrderPriceObjectId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceNameFilter(
            workOrderId: $workOrderId
            chapter: $chapter
            workOrderPriceObjectId: $workOrderPriceObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const workOrderUnitFilterGql = graphql(`
    query uerWorkOrderPriceUnitFilter(
        $workOrderId: Long!
        $chapter: ChapterEnum!
        $workOrderPriceObjectId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerWorkOrderPriceUnitFilter(
            workOrderId: $workOrderId
            chapter: $chapter
            workOrderPriceObjectId: $workOrderPriceObjectId
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
